export default __webpack_public_path__ + "static/media/early-funding.65fefda4.svg";